import { render, staticRenderFns } from "./SeriesImageWithWireframe.vue?vue&type=template&id=1815dfd0&"
import script from "./SeriesImageWithWireframe.vue?vue&type=script&lang=js&"
export * from "./SeriesImageWithWireframe.vue?vue&type=script&lang=js&"
import style0 from "./SeriesImageWithWireframe.vue?vue&type=style&index=0&id=1815dfd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports